module.exports = __webpack_public_path__ + "media/src/images/backgrounds/portfolio-9b4aa335f8d0abd98fd2ff5752cefbf8.svg";